import React, { useEffect, useState } from "react";
import AgGridComponent from "../../../../Components/CommonComponents/AG-Grid";
import {
  Box,
  AddOutlined,
  useNavigate,
  useLocation,
} from "../../../../Collections/Imports";
import {
  useApiCallMutation,
  useGetApiCallQuery,
} from "../../../../Services/ApiCallService";
// import { removeSinglePingTree } from "../../../../Store/PingTreeModule";
import { pingtreeApiEndPoints } from "../../../../Config/APIsEndpoints";
import { useDispatch, useSelector } from "react-redux";
import AddEditPingTree from "../../../../Forms/AddEditPingTree";
import CircularProgressBar from "../../../../Components/UIComponents/CircularProgressBar";

import { Outlet } from "react-router-dom";
import ImportNewTreeButton from "../../../../Forms/TieredTreeBuilder/ImportNewTreeButton";
import {
  getTableDataRedirect,
  removeSingleRedirectPingTree,
} from "../../../../Store/PingTreeModule/PingTreeRedirect";

const RedirectPingTree = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let location = useLocation();
  const [rowSelected, setRowSelected] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);
  // Form pagination handler
  const [paginationIndex, setPaginationIndex] = useState(0);
  const [itemPerIndex, setItemPerIndex] = useState(100);
  const perPageCountOptions = [
    { label: "100", value: 100 },
    { label: "500", value: 500 },
    { label: "1000", value: 1000 },
  ];
  const handlePageChange = (data) => {
    setPaginationIndex(data);
  };
  const handleRowsPerPageChange = (data) => {
    setItemPerIndex(data);
    setPaginationIndex(0);
  };
  const [isOpenAddEditBox, setIsOpenAddEditBox] = useState(false);

  const TableData = useSelector((state) => state.PingTreeRedirect?.tableData);
  // Post PingTree
  const [GetPingTreeList, PingTreeList] = useApiCallMutation();

  useEffect(() => {
    GetPingTreeList({
      endPoint: pingtreeApiEndPoints.getPingtreeList,
      method: "POST",
      data: {
        data: { pingTreeType: "Redirect" },
      },
    });
  }, []);

  useEffect(() => {
    if (PingTreeList?.isSuccess && PingTreeList?.data?.data?.pingTree) {
      const tableData = {
        data: PingTreeList?.data?.data?.pingTree,
        headers: PingTreeList?.data?.data?.headers,
      };

      dispatch(getTableDataRedirect(tableData));
    }
  }, [PingTreeList]);

  // delete pentree
  const [DeletePingTree, DeletePingTreeData] = useApiCallMutation();

  const handleActions = (previousData, action) => {
    switch (action) {
      case "EDIT":
        setRowSelected(previousData);
        setIsEditMode(true);
        setIsOpenAddEditBox(true);
        break;
      case "DELETE":
        // console.log("delete ho raha hu");
        const treeUniqueId = {
          treeUniqueId: previousData?.treeUniqueId,
        };
        DeletePingTree({
          endPoint: pingtreeApiEndPoints.deletePingTree,
          method: "POST",
          data: { data: treeUniqueId },
        });
        dispatch(removeSingleRedirectPingTree(previousData?.treeUniqueId));
        break;
      case "CONFIG":
        setRowSelected(previousData);
        sessionStorage.setItem(
          "currentPingTreeRowData",
          JSON.stringify(previousData)
        );
        // dispatch(updateCampaignRowData(previousData));
        const currentPingTreeData = JSON.parse(
          sessionStorage.getItem("currentPingTreeRowData")
        );

        // setCampainName(currentCampData.campaignName);
        navigate(String(currentPingTreeData?.treeUniqueId));

        break;
      default:
    }
  };

  return (
    <>
      {location?.pathname === "/ping-tree" && (
        <>
          {/* <PageHeader title={"Pign Tree"} helpText={"Pign Tree"} /> */}
          {/* {PingTreeList.isLoading && <CircularProgressBar />} */}
          {/* {!PingTreeList.isLoading && ( */}
          <Box>
            <ImportNewTreeButton treeType="Redirect" />
            <AgGridComponent
              rowData={TableData?.data || []}
              columnDefs={TableData?.headers || []}
              tableName={"Redirect PignTree"}
              actions={["EDIT", "DELETE", "CONFIG"]}
              performAction={handleActions}
              totalPageCount={TableData?.data.length}
              paginationIndex={paginationIndex}
              itemPerIndex={itemPerIndex}
              perPageCountOptions={perPageCountOptions}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
              rowMode
              addAction={setIsOpenAddEditBox}
              AddButtonName={"Add New Tree"}
              addActionIcon={<AddOutlined />}
            />
          </Box>
          {/* )} */}
          {isOpenAddEditBox && (
            <AddEditPingTree
              TreeType="Redirect"
              defaultValues={rowSelected}
              isOpen={isOpenAddEditBox}
              setOpen={setIsOpenAddEditBox}
              isEditMode={isEditMode}
              setIsEditMode={setIsEditMode}
            />
          )}
        </>
      )}
      <div>
        <Outlet />
      </div>
    </>
  );
};

export default RedirectPingTree;
